module.exports = __webpack_public_path__ + "img/cell-min.9f92525e.png";